import { FC, ReactNode } from 'react';

import { NavBar } from '@hh.ru/magritte-ui';
import type { TitleContainerProps } from '@hh.ru/magritte-ui';

interface MagritteModalHeaderProps {
    title: ReactNode;
    subtitle?: ReactNode;
    actions?: ReactNode;
    options?: ReactNode;
    centered?: boolean;
    size?: TitleContainerProps['size'];
}

export const MagritteModalHeader: FC<MagritteModalHeaderProps> = ({
    title,
    subtitle,
    actions,
    options,
    centered = false,
    size = 'large',
}) => (
    <div data-qa="modal-header">
        <NavBar>
            <NavBar.Pane>
                <NavBar.Stage>
                    <NavBar.Actions right={actions} centered={centered}>
                        <NavBar.TitleContainer title={title} subtitle={subtitle} centered={centered} size={size} />
                    </NavBar.Actions>
                    {options}
                </NavBar.Stage>
            </NavBar.Pane>
        </NavBar>
    </div>
);
